export default "__VITE_ASSET__BA_htL0E__"